export default {
  step: 0,
  currentStep: 0,
  steps: [
      { name: 'Step 1', },
      { name: 'Step 2', },
      { name: 'Step 3', },
      { name: 'Step 4', },
      { name: 'Step 5', },
  ],
  orders: [],
  products: [],
  productsDetailOrder: []
};
